import {Post} from "../pages/news-blog-deutsch-sprachschule";

export const reducePostsArrayToPages = (posts: Post[], pageSize: number) => {
    let pages: Post[][] = []
    for (let i = 0; i < posts.length; i += pageSize) {
        pages.push(posts.slice(i, i + pageSize));
    }
    return pages;
}